import React from 'react';
import { Flex, Label, Text } from '@leverege/ui-elements';
import S from './InputGroup.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function InputGroup(props) {
  const {
    onChange,
    eventData,
    value,
    title,
    error,
    editor: Editor,
    disabled,
    editorProps,
    dataCy
  } = props;
  return /*#__PURE__*/_jsxs(Flex, {
    className: S.root,
    variant: "colS",
    children: [/*#__PURE__*/_jsx(Label, {
      variant: "inputTitle",
      children: title
    }), /*#__PURE__*/_jsx(Editor, {
      "data-cy": dataCy,
      value: value,
      eventData: eventData,
      onChange: onChange,
      disabled: disabled,
      ...editorProps
    }), /*#__PURE__*/_jsx(Text, {
      variant: "inputCaptionSmallError",
      children: error
    })]
  });
}